import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * ProcessVariant Partial Translation Cell
 * Translates processVariant enum into understandable values
 */
export const processVariantPartial: Columns<any> = {
  title: 'table.processvariant.title',
  key: 'processVariant',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'notspecified': 'enum.settlement.processvariant.notspecified',
    'firstrun': 'enum.settlement.processvariant.firstrun',
    'secondrun': 'enum.settlement.processvariant.secondrun',
    'thirdrun': 'enum.settlement.processvariant.thirdrun',
  }
}
